import React, { useCallback } from 'react';
import { getProductIdentifierAttributes } from 'unified-help-center-alpha/src/utils/analytics/get-product-identifier-attributes';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ExperienceType } from '@atlassian/conversation-assistant';
import { BackButton } from '@atlassian/help-center-common-component/back-button';
import { getAnalyticsWebClient } from '@atlassian/help-center-common-util/analytics/client';

export const ConversationNavBar = () => {
    const analyticsClient = getAnalyticsWebClient().getInstance();

    const onBackButtonClick = useCallback(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendUIEvent({
            source: 'uhConversationScreen',
            action: 'clicked',
            actionSubject: 'backButton',
            actionSubjectId: 'backToHelpCenterHome',
            attributes: {
                ...getProductIdentifierAttributes(ExperienceType.UNIFIED_HELP),
            },
        });
        // TODO -> rendering on the same path doesn't allow goBack() is no history from router fix this
        window.location.reload();
    }, [analyticsClient]);

    return (
        <Box xcss={navBarStyles}>
            <Inline alignBlock="center" alignInline="center" grow="fill">
                <Box xcss={navBarBackButtonStyles}>
                    <BackButton actionSubjectId="closeSearch" onClick={onBackButtonClick} />
                </Box>
            </Inline>
        </Box>
    );
};

export default withAnalyticsEvents()(ConversationNavBar);

const navBarStyles = xcss({
    display: 'flex',
    position: 'fixed',
    height: token('space.600', '56px'),
    width: '100%',
    backgroundColor: 'elevation.surface.overlay',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: token('color.border', colors.N30),
    zIndex: 'modal',
});

const navBarBackButtonStyles = xcss({
    position: 'fixed',
    left: token('space.050', '4px'),
    [media.above.sm]: {
        left: token('space.200', '16px'),
    },
    [media.above.xs]: {
        left: token('space.100', '8px'),
    },
});
